import uk.co.nickthecoder.kyd.Actor

abstract class Collectable : Item() {

    open fun collect(collectedActor: Actor) {
        collectedActor.parent.removeActor(collectedActor)
        PlayDirector.instance.grid[gridX][gridY] = null
    }

}

